export enum EError {
  SAME_PLAYLIST_LOADED_MORE_TIMES = 'Same playlist was loaded more than expected times. Looks lise server is malfunctioning',
}

export class NetworkError extends Error {
  public statusCode: number;
  public statusText: string;

  constructor(message: string, code: number, text: string) {
    super(message);
    this.name = 'DoppioNetworkError';
    this.statusCode = code;
    this.statusText = text;
  }
}
